import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '../ui/select';
import { Loader2 } from 'lucide-react';

const PRIORITY_STYLES = {
  high:   { active: 'bg-red-500 text-white border-red-500',     inactive: 'bg-red-50 text-red-700 border-red-200' },
  medium: { active: 'bg-amber-500 text-white border-amber-500', inactive: 'bg-amber-50 text-amber-700 border-amber-200' },
  low:    { active: 'bg-emerald-500 text-white border-emerald-500', inactive: 'bg-emerald-50 text-emerald-700 border-emerald-200' },
};

export function QuickRéserveMode({
  quickRéserve, setQuickRéserve, chantiers,
  isProcessing, onSave, onCancel,
}) {
  return (
    <div className="space-y-4 py-4">
      <div className="text-left">
        <Label>Chantier *</Label>
        <Select value={quickRéserve.chantier_id} onValueChange={(value) => setQuickRéserve({...quickRéserve, chantier_id: value})}>
          <SelectTrigger className="mt-1 h-14 text-base" data-testid="quick-réserve-chantier">
            <SelectValue placeholder="Sélectionner un chantier" />
          </SelectTrigger>
          <SelectContent position="popper" className="z-[100]">
            {chantiers.map(c => (
              <SelectItem key={c.id} value={c.id} className="py-3">{c.name}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div>
        <Label>Titre de la réserve *</Label>
        <Input
          value={quickRéserve.title}
          onChange={(e) => setQuickRéserve({...quickRéserve, title: e.target.value})}
          placeholder="Ex: Fissure mur RDC"
          className="mt-1 h-14 text-base"
          data-testid="quick-réserve-title"
        />
      </div>

      <div>
        <Label>Localisation</Label>
        <Input
          value={quickRéserve.location}
          onChange={(e) => setQuickRéserve({...quickRéserve, location: e.target.value})}
          placeholder="Ex: Bâtiment A, Niveau 2"
          className="mt-1 h-14 text-base"
          data-testid="quick-réserve-location"
        />
      </div>

      <div>
        <Label>Priorite</Label>
        <div className="grid grid-cols-3 gap-2 mt-1">
          {[
            { value: 'high', label: 'Haute' },
            { value: 'medium', label: 'Moyenne' },
            { value: 'low', label: 'Basse' }
          ].map(p => {
            const isSelected = quickRéserve.priority === p.value;
            const pStyle = PRIORITY_STYLES[p.value];
            return (
              <button
                key={p.value}
                onClick={() => setQuickRéserve({...quickRéserve, priority: p.value})}
                className={`py-4 rounded-xl font-semibold transition-all border-2 ${isSelected ? pStyle.active : pStyle.inactive}`}
              >
                {p.label}
              </button>
            );
          })}
        </div>
      </div>

      <div className="flex gap-3 pt-4">
        <Button variant="outline" onClick={onCancel} className="flex-1 h-14">
          Annuler
        </Button>
        <Button
          onClick={onSave}
          disabled={isProcessing || !quickRéserve.chantier_id || !quickRéserve.title}
          className="flex-1 h-14 bg-emerald-600 hover:bg-emerald-700"
          data-testid="quick-réserve-save"
        >
          {isProcessing ? <Loader2 className="animate-spin" /> : 'Créer'}
        </Button>
      </div>
    </div>
  );
}
